import { planningAPI } from "../../axios";

export const actions = {
     // DepartmentPreOpcr
    AddDepartmentOPCR(context, data){
        return planningAPI.post(`DepartmentPreOpcr/Add`, data);
    },
    GetSingleDepartmentOPCR(context, data){
        return planningAPI.get(`DepartmentPreOpcr/${data}`);
    },
    UpdateDepartmentOPCR(context, data){
        return planningAPI.put(`DepartmentPreOpcr/${data.id}`, data);
    },
    RemoveDepartmentOPCR(context, data){
        return planningAPI.delete(`DepartmentPreOpcr/${data}`);
    },
    GetAllDepartmentOPCR(context, data){
        return planningAPI.get(`DepartmentPreOpcr/All/${data.departmentId}/${data.cycle}`);
    },
    PostDepartmentOPCR(context, data){
        return planningAPI.post(`DepartmentPreOpcr/Post/${data}`);
    },
    GetAllPostedOPCR(context, data){
        return planningAPI.get(`DepartmentPreOpcr/Posted/${data.deliveryUnitId}/${data.cycle}`);
    },
    ReturnDepartmentOPCR(context, data){
        return planningAPI.post(`DepartmentPreOpcr/Return/${data}`);
    }
}